import styled from 'styled-components';

export const TypographyWrapper = styled.div`
    // TODO: This is a temporary component wrapper until we can
    // fix the Typography component.
    text-align: center;

    & > * {
        line-height: 1.2;
    }
`;
